<template>
  <div class="spinner mx-auto flex justify-center self-center text-center py-6">
    <fingerprint-spinner
      :animation-duration="animationDuration"
      :size="size"
      :color="'#ee577c'"
    />
    <slot />
  </div>
</template>

<script>
import { FingerprintSpinner } from 'epic-spinners';

export default {
  name: 'Spinner',

  components: {
    FingerprintSpinner,
  },

  props: {
    animationDuration: {
      type: Number,
      required: false,
      default: 1000,
    },

    size: {
      type: Number,
      required: false,
      default: 100,
    },
  },

};
</script>
